// extracted by mini-css-extract-plugin
export default {"tab_button":"styles_tab_button__OowPT","active":"styles_active__ZBsxG","disabled":"styles_disabled__4bONV"};